import { useReducer } from 'react';
import { FormField, Select } from 'grommet';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { ManagedCloudServiceFormFieldsState } from '@customTypes/stateTypes';
import { helpWithOptions, severityOptions } from './ManagedCloudServiceFormOptions';

export const ManagedCloudServiceFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: ManagedCloudServiceFormFieldsState, newState: Partial<ManagedCloudServiceFormFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: ''
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    clearFirstSelectState();
    updateState({ helpWith: option });
    props.onDetailsChange({ showDetails: true });
  };

  const clearState = (): void => {
    clearFirstSelectState();
    updateState({ helpWith: '' });
  };

  props.onReset && props.onReset(clearState);

  const clearFirstSelectState = (): void => {
    props.onDetailsChange({ showDetails: false });
  };

  return (
    <>
      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(helpWithOptions)}
        onChange={helpWithChange}
      />

      <FormField name="severity" htmlFor="severity" label="Severity (business impact)" style={{ display: 'none' }} required>
        <Select id="severity" name="severity" placeholder="Select" value={severityOptions.medium} options={Object.values(severityOptions)} />
      </FormField>
    </>
  );
};
